import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
export const Title = styled.h2`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  line-height: 37px;
  color: var(--color-yellow);
`;

export const ContentContainer = styled.div`
  @media (min-width: 1024px) {
    display: flex;
    justify-content: center;
    gap: 10rem;
  }
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 1024px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 15vw;
  }
`;

export const SocialContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  

  a:visited {
    color: white;
  }

  svg {
    font-size: 30px;
    transition: 0.3s;
    cursor: pointer;

    &:hover {
      transform: scale(1.2);
      color: var(--color-yellow);
    }
  }
`;

export const Paragraph = styled.p`
  font-size: 20px;
  font-family: var(--font-workSans);
  line-height: 32px;
  text-align: justify;
  margin: 1rem 0;
`;

export const Social = styled.div`
  display: flex;
  gap: 2rem;
`;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;

  textarea {
    height: 240px;
    background-color: rgba(255, 218, 109, 0.2);
    border: none;
    border-radius: 10px;
    color: white;
    padding: 1rem;
    font-size: 20px;

    &::placeholder {
      font-family: var(--font-raleway);
      font-size: 16px;
    }
  }

  @media (min-width: 1024px) {
    width: 40%;
    
  }
`;

export const Label = styled.label`
  font-family: var(--font-workSans);
  font-size: 18px;
  line-height: 23px;
  align-self: flex-start;
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
